/**
 * Definiition of different attachment types
 */
export var ATTACHMENT_TYPE;
(function (ATTACHMENT_TYPE) {
  ATTACHMENT_TYPE[ATTACHMENT_TYPE["TASK"] = 0] = "TASK";
  ATTACHMENT_TYPE[ATTACHMENT_TYPE["CUSTOMER"] = 1] = "CUSTOMER";
  ATTACHMENT_TYPE[ATTACHMENT_TYPE["DEVICE"] = 2] = "DEVICE";
  ATTACHMENT_TYPE[ATTACHMENT_TYPE["HANDHOLE"] = 3] = "HANDHOLE";
  ATTACHMENT_TYPE[ATTACHMENT_TYPE["FIBER"] = 4] = "FIBER";
  ATTACHMENT_TYPE[ATTACHMENT_TYPE["SPLICE"] = 5] = "SPLICE";
})(ATTACHMENT_TYPE || (ATTACHMENT_TYPE = {}));